export default function isFilled(data){
    return data != null && data.length > 0;
}